module.exports = __webpack_public_path__ + "static/media/man-solved-market.bec40607.jpeg";